import { format } from 'date-fns';
import type { FormikProps } from 'formik';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { StyledButton, StyledTextField } from '../../components';
import type { ISignAgreementFields, ISignAgreementValues, OnChangeEvent } from '../../types';

const Form = styled('form')`
	display: grid;
	grid-template-column: 1fr 1fr 1fr 1fr;
	grid-template-row: 1fr 1fr;
	width: 100%;
	column-gap: 2rem;
`;

interface IAgreementFormProps {
	onSave?: (v: ISignAgreementValues) => void;
}

export const SignForm = (props: FormikProps<ISignAgreementValues> & IAgreementFormProps) => {
	const navigate = useNavigate();
	const location = useLocation();
	const [isDisabled, setIsDisabled] = useState(false);
	const { values, errors, touched, handleChange, isValid, setFieldTouched } = props;
	const fields: ISignAgreementFields = {
		signature: { name: 'signature', label: 'Your Name' },
		timestamp: { name: 'timestamp', label: "Today's Date and Time" },
	};

	useEffect(() => {
		setIsDisabled(true);
	}, []);

	const change = (name: any, e: OnChangeEvent) => {
		e.persist();
		handleChange(e);
		setFieldTouched(name, true, false);
	};

	return (
		<Form onSubmit={props.handleSubmit} onReset={props.handleReset}>
			<StyledTextField
				style={{ gridColumn: '1 / span 3', gridRow: 1 }}
				value={values.signature || ''}
				name={fields.signature.name}
				label={fields.signature.label}
				helperText={touched.signature ? errors.signature : ''}
				error={touched.signature && errors.signature !== undefined}
				onChange={(e: OnChangeEvent) => change(fields.signature.name, e)}
			/>
			<StyledTextField
				style={{ gridColumn: 4, gridRow: 1 }}
				disabled={isDisabled}
				value={format(new Date(values.timestamp), 'MM/dd/yyyy p')}
				name={fields.timestamp.name}
				label={fields.timestamp.label}
			/>
			<StyledButton
				style={{ gridColumn: '1 / span 2', gridRow: 2, justifySelf: 'center' }}
				onClick={() => navigate(`/agreement/update?id=${location.state.fleetCompanyId}`)}
			>
				Back
			</StyledButton>
			<StyledButton
				style={{ gridColumn: '3 / span 2', gridRow: 2, justifySelf: 'center' }}
				type="submit"
				disabled={!isValid}
			>
				I Accept This Agreement
			</StyledButton>
		</Form>
	);
};
